import { EntityRepository, Repository } from "typeorm";
import { Locations } from "../location.entity";



@EntityRepository(Locations)
export class LocationsRepository extends Repository<Locations>{

}
